import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as actions from '../../../state';
import { changeBoard } from '../../../events';
import styles from './styles.module.css';
import { selectLayout } from '../../../state';

const messages = defineMessages({
  BOARD_NAME: {
    id: 'BOARD_NAME',
    defaultMessage: 'Board name',
  },
  EDIT_BOARD_NAME: {
    id: 'EDIT_BOARD_NAME',
    defaultMessage: 'Edit board name',
  },
});

function BoardName() {
  const dispatch = useDispatch();
  const ref = useRef();

  const board = useSelector(actions.readStateBoard);
  const layout = useSelector(selectLayout);
  const user = useSelector(actions.readStateUser);

  const [value, setValue] = useState(0);

  const [editName, setEditName] = useState(false);

  const handleChange = (e) => {
    board.name = e.target.value;
    dispatch(actions.isDirty(true));
    setValue(value + 1);
  };

  const routeToBoard = () => {
    dispatch(changeBoard(board.id, false));
  };

  if (!editName) { // not editing the name
    if (layout.editMode) { // in edit mode
      return (
        <div className={`${styles.flex2} ${styles.boardNameContainer}`}>
          <Tooltip
            disableFocusListener
            placement="bottom-start"
            title={<FormattedMessage {...messages.EDIT_BOARD_NAME} />}
            classes={{ tooltip: styles.boardNameTooltip }}
          >
            <div style={{ display: 'inline' }}>
              <Typography
                gutterBottom
                onClick={() => setEditName(true)}
                className={`${styles.boardName} animate__animated animate__fadeIn`}
                style={{ cursor: 'pointer' }}
              >
                {board.name}
              </Typography>

              <IconButton onClick={() => setEditName(true)} style={{ padding: 8 }}>
                <EditIcon style={{ fontSize: 18 }} />
              </IconButton>
            </div>
          </Tooltip>
        </div>
      );
    } // in view mode

    if (user && layout.editMode) {
      return (
        <div className={`${styles.flex2} ${styles.boardNameContainer}`}>
          <Typography
            gutterBottom
            onClick={routeToBoard}
            title={board.name}
            className={`${styles.boardName} animate__animated animate__fadeIn`}
          >
            {board.name}
          </Typography>
        </div>
      );
    }

    return (
      <div className={`${styles.flex2} ${styles.boardNameContainer}`}>
        <Typography
          gutterBottom
          title={board.name}
          className={`${styles.noUserBoardName} animate__animated animate__fadeIn`}
        >
          {board.name}
        </Typography>
      </div>
    );
  } // editing the name

  return (
    <div className={`${styles.flex4} ${layout.showRightSidebar && styles.editingTitle}`}>
      <TextField
        autoFocus
        id="title"
        value={board.name}
        label={<FormattedMessage {...messages.BOARD_NAME} />}
        className={`${styles.boardNameInput} animate__animated animate__fadeIn`}
        onChange={handleChange}
        onBlur={() => setEditName(false)}
        margin="normal"
        inputRef={ref}
        InputLabelProps={{
          shrink: true,
          // className: styles.boardInput,
        }}
      />
    </div>
  );
}

export default BoardName;
